/* unplugin-vue-components disabled */import script from "./credit-limit-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./credit-limit-modal.vue?vue&type=script&setup=true&lang=js"

import "./credit-limit-modal.vue?vue&type=style&index=0&id=254b8399&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254b8399"]])

export default __exports__